<template>
	<div class="receipt-box">
		<v-alert type="error" class="mb-1 ml-2 mr-1" v-if="error_msg.length !== 0">{{
			error_msg
		}}</v-alert>
		<ProgressGetDataLinear v-if="settings_loading" class="px-5"/>
		<v-row v-if="!settings_loading" no-gutters>
			<v-col v-if="receipt && receipt.id > 0" :cols="$vuetify.breakpoint.xsOnly ? 12: 4" class="px-2 pt-1">
				<div v-if="image_type.length !== 0" style="width: 100%">
					<img v-if="image_type === 'application/pdf' && image.length === 1" :src="image[0]" width="100%"/>
					<v-carousel v-if="image_type === 'application/pdf' && image.length > 1" v-model="multi_pdf_model" hide-delimiters height="100%">
						<v-carousel-item
							v-for="(image_item, index) in image"
							:key="index"
						>
							<img :src="image_item" width="100%"/>
						</v-carousel-item>
					</v-carousel>
					<img v-if="image_type !== 'application/pdf'" :src="image" width="100%"/>
					<v-btn small depressed color="#82899B" class="image-remove white--text text-capitalize" @click="onImageRemove()">
						<v-icon small class="mr-1">mdi-close</v-icon>
						Remove
					</v-btn>
				</div>
				<v-img v-if="loading" :lazy-src="image" :max-width="($vuetify.breakpoint.width - 100)" class="image-loading" style="height: 400px">
					<template v-slot:placeholder>
						<v-row
							class="fill-height ma-0"
							align="center"
							justify="center"
						>
							<v-progress-circular
								:size="50"
								:width="5"
								color="grey lighten-5"
								indeterminate
							></v-progress-circular>
						</v-row>
					</template>
				</v-img>
			</v-col>
			<v-img v-if="!image && receipt && receipt.id === 0" :lazy-src="image" class="image-loading" style="height: 400px">
				<template v-slot:placeholder>
					<v-row
						class="fill-height ma-0"
						align="center"
						justify="center"
					>
						<v-progress-circular
							:size="50"
							:width="5"
							color="grey lighten-5"
							indeterminate
						></v-progress-circular>
					</v-row>
				</template>
			</v-img>
			<v-col :cols="image_type.length !== 0 || loading ? ($vuetify.breakpoint.xsOnly ? 12: 8) : 12" class="px-2">
				<div class="receipt-box-text mt-0">
					Expense Date
				</div>
				<v-row class="ma-0" justify="space-between">
					<DatePicker
						:color="color"
						:lableText="''"
						:isOutlined="true"
						:isIcon="true"
						:dateInit="expenses_date_init"
						@date="expenses_date = $event"
					/>
					<v-btn
						v-if="!image && receipt.id > 0"
						depressed
						outlined
						color="#00AAFD"
						height="40"
						class="add-file-button text-capitalize"
						@click="onAddFile()"
					>
						<v-icon size="24" class="mr-2">mdi-plus</v-icon>
						<span>Add File</span>
					</v-btn>
				</v-row>
				<v-row class="ma-0">
					<v-col cols="12" class="pa-0">
						<div class="receipt-box-text">Job</div>
						<v-autocomplete
							v-model="job"
							:items="job_items"
							:loading="job_loading"
							:search-input.sync="jobSearch"
							:color="color"
							:placeholder="`Type to search`"
							background-color="#FAFAFA"
							item-text="display_name"
							item-value="id"
							:item-color="color"
							item-disabled="disabled"
							auto-select-first
							outlined
							dense
							hide-no-data
							hide-details
							return-object
							clearable
							@change="onSelectJob($event)"
						>
						</v-autocomplete>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-4">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pr-2'">
						<div class="receipt-box-text">Phase</div>
						<v-select
							v-model="phase"
							:items="phase_items"
							item-text="display_name"
							item-value="id"
							:item-color="color"
							background-color="#FAFAFA"
							dense
							hide-details
							return-object
							outlined
							:color="color"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 mt-4' : 'pa-0 pl-2'">
						<div class="receipt-box-text">Kind</div>
						<KindTreeSelection
							:elementKey="`kind`"
							:color="color"
							:placeholder="'Type to search'"
							:kindParams="kindParams"
							:bgColor="'#FAFAFA'"
							:kindSelected="kind_init"
							@kind-selected="onKindSelected($event)"
						/>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-4">
					<v-col cols="12" class="pa-0">
						<div class="receipt-box-text">Description</div>
						<v-text-field
							v-model="description"
							:color="color"
							background-color="#FAFAFA"
							outlined
							hide-details
							dense
						/>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-4">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pr-1' : 'pa-0 pr-1'">
						<div class="receipt-box-text">Currency</div>
						<v-select
							v-model="currency"
							:items="currencies"
							item-text="code"
							item-value="id"
							:item-color="color"
							background-color="#FAFAFA"
							dense
							hide-details
							return-object
							outlined
							:color="color"
							@change="onCurrencyChange($event)"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pl-1' : 'pa-0 pl-1 pr-2'">
						<div class="receipt-box-text">Amount</div>
						<v-text-field
							:value="formatAmount(amount)"
							class="text-right"
							background-color="#FAFAFA"
							dense
							hide-details
							:color="color"
							outlined
							min="0"
							oninput="if(this.value < 0) this.value = 0"
							@change="amount = parseAmount($event)"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pr-1 mt-4' : 'pa-0 pl-2 pr-1'">
						<div class="receipt-box-text">Tax</div>
						<v-text-field
							:value="formatAmount(tax_amount)"
							class="text-right"
							background-color="#FAFAFA"
							dense
							hide-details
							:color="color"
							:disabled="isTaxDisabled"
							outlined
							min="0"
							oninput="if(this.value < 0) this.value = 0;"
							@change="onTaxAmountChange($event)"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pl-1 mt-4' : 'pa-0 pl-2'">
						<div class="receipt-box-text">To Pay</div>
						<v-text-field
							:value="toPay"
							background-color="#FAFAFA"
							outlined
							disabled
							dense
							hide-details
						/>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-4">
					<v-btn class="text-capitalize px-1" color="#82899B" text @click="onShowToogle()">
						<span v-if="is_show_toogle">Hide tax and markup</span>
						<span v-else>Change tax and markup</span>
					</v-btn>
				</v-row>
				<v-row v-if="is_show_toogle" class="mx-0 mt-2 mb-4">
					<v-col v-if="isShowMarkup" :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pr-1'">
						<div class="receipt-box-text">Mark up</div>
						<v-text-field
							class="mark-up-field"
							:value="formatAmount(markup_perc)"
							:color="color"
							background-color="#FAFAFA"
							append-icon="mdi-percent"
							dense
							hide-details
							outlined
							min="0"
							oninput="if(this.value < 0) this.value = 0;"
							:disabled="isMarkupDisabled"
							@change="markup_perc = parseAmount($event)"
						/>
					</v-col>
					<v-col v-if="isShowMarkup" :cols="$vuetify.breakpoint.xsOnly ? 6:3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pl-1 pr-2'">
						<div class="receipt-box-text">Value</div>
						<v-text-field
							:value="valueAmount"
							outlined
							disabled
							dense
							hide-details
							background-color="#FAFAFA"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pl-1 pr-2'">
						<div class="receipt-box-text">Tax Settings</div>
						<v-select
							v-model="tax_setting"
							:items="tax_settings"
							:item-color="color"
							background-color="#FAFAFA"
							dense
							hide-details
							return-object
							outlined
							:color="color"
							@change="onTaxSettingChange"
						/>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-4">
					<v-btn class="text-capitalize white--text mr-3 mt-4" color="#00AAFD" depressed :disabled="!isSaveEnabled" @click="onSave()">
						Save Expense
					</v-btn>
					<v-btn class="text-capitalize mt-4" color="#82899B" depressed outlined @click="onCancel()">
						Cancel
					</v-btn>
				</v-row>
			</v-col>
		</v-row>						
	</div>
</template>
<script>
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import DatePicker from "@/components/date/date_picker.vue";

import moment from 'moment';
import config from "@/config.js";

export default {
	name:'NewEditReceipt',
	props: {
		color: {
			type: String,
			default: '',
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		receipt: {
			type: Object,
			default: () => {}
		},
		isShowMarkup: {
			type: Boolean,
			default: false,
		},
		isEditMarkup: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		KindTreeSelection,
		DatePicker,
		ProgressGetDataLinear
	},
	data() {
		const receipt = this.receipt;

		return {
			error_msg: '',
			settings_loading: false,
			job_loading :false,
			jobSearch: null,
			user_id: 0,

			expenses_date: receipt ? receipt.date : null,
			expenses_date_init : receipt ? receipt.date : null,
			job: receipt ? receipt.job : null,
			job_items: receipt ? [receipt.job]: [],
			phase: receipt ? receipt.phase : null,
			phase_items: receipt && receipt.phase ? [receipt.phase] : [],
			kind_init: receipt ? receipt.kind : null,
			kind: receipt ? receipt.kind : null,
			description: receipt ? receipt.desc :'',
			
			currency: receipt && receipt.currency ? receipt.currency : null,
			amount: receipt ? receipt.value : 0,
			tax_perc: receipt ? receipt.tax_perc : 0,
			tax_amount: receipt ? receipt.tax_amount : 0,
			markup_perc: receipt ? receipt.markup_perc : 0,
			has_tax: receipt ? receipt.has_tax : true,

			tax_setting: null,
			tax_settings: config.tax_settings,
			
			image: receipt ? receipt.image : '',
			image_type: receipt ? receipt.image_type : '',
			loading: receipt ? receipt.loading : false,
			multi_pdf_model: 0,

			is_show_toogle: true,
		}
	},
	computed: {
		kindParams() {
			const kind_params = {
				select_kinds: true,
				select_items: true,
				expense_kinds: true,
				overhead_mode: 0
			};

			if (this.job) {
				if (this.job.is_overhead === true) {
					kind_params.overhead_mode = 2;
				} else {
					kind_params.overhead_mode = 1;
				}
			}
			return kind_params;
		},
		toPay() {
			const amount = Number(this.amount) || 0;
			const tax = Number(this.tax_amount) || 0;
			const to_pay = amount + tax;

			return this.formatAmount(to_pay);
		},
		valueAmount() {
			const amount = Number(this.amount) || 0;
			const mark_up_tmp = Number(this.markup_perc) || 0;
			const value_amount = amount + (amount * mark_up_tmp * 0.01);

			return this.formatAmount(value_amount);
		},
		isSaveEnabled() {
			return this.expenses_date
				&& this.job !== null
				&& this.phase !== null
				&& this.kind !== null
				&& this.currency !== null
				&& Number(this.amount) !== 0;
		},
		isMarkupDisabled() {
			return !this.isEditMarkup
				|| Number(this.markup_perc) < 0
				|| (this.expense && this.expense.once_paid === true)
				|| (this.job && this.job.is_overhead === true)
				|| (this.kind && Number(this.kind.overhead_mode) === 2);
		},
		isTaxDisabled() {
			const tax_setting_value = this.tax_setting ? Number(this.tax_setting.value) : null;
			return tax_setting_value === 1 || tax_setting_value === 4;
		}
	},
	watch: {
		receipt: {
			handler: function () { 
				this.image = this.receipt.image;
				this.image_type = this.receipt.image_type;
				this.loading = this.receipt.loading;
			},
			deep: true
		},
		jobSearch(val) {
			this.job ? val && val !== this.job.display_name && this.jobQuery(val) : val && this.jobQuery(val);
		},
		phase() {
			if (this.phase && this.job && this.kind) {
				this._checkKind(this.job.id, this.kind.id, this.phase.id);
			}
		},
		amount(new_val, old_val) {
			if (old_val !== new_val) {
				const countries = this.currency.countries || [];
				const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
				if (!country) return;

				this.tax_perc = Number(country.tax_perc);
				this.tax_amount = this.has_tax ? Number(new_val) * this.tax_perc * 0.01 : 0;
						
				/** has_tax=true => Tax applies; has_tax=false => Tax free */
				this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
				this.onTaxSettingChange(this.tax_setting);
			}
		},
	},
	async created() {
		await this.getCurrentUserId();
		this.getSettings();
	},
	methods: {
		formatAmount(value) {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		parseAmount(value) {
			const amount = Number(String(value).replace(/,/g, ''));

			return Number.isNaN(amount) ? 0 : amount;
		},
		async getCurrentUserId() {
			this.settings_loading = true;

			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.settings_loading = false;
				});
		},
		getSettings() {
			this.settings_loading = true;
			const usid = this.user_id;
			const winname = 'webclaim';

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const toogle = windata.toogle;
								if (toogle !== null || toogle !== undefined) {
									this.is_show_toogle = toogle;
								}
							}
						}
						this.settings_loading = false;
					} else {
						this.error_msg = reason;
						this.settings_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.settings_loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname = 'webclaim';

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		getMarkup(job_id, kind_id) {
			let url = "/api/config/rates/markup";

			const params = [];
			params.push("job_id=" + job_id);
			params.push("kind_id=" + kind_id);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.markup_perc = data * 100;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		jobQuery(key) {
			this.job_loading = true;
			
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));
			params.push("status_groups=" + config.job_status_group_nomal.toString());
			params.push('is_lookup' + '=' + encodeURIComponent(false));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];

						this.job_items = data_filter;
						this.job_loading = false;
					} else {
						this.error_msg = reason;
						this.job_loading = false;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					this.job_loading = false;
				})
				.finally(() => {
					this.job_loading = false;
				});
		},
		onSelectJob(job) {
			if (job) {
				this.getPhases(job.id);

				if (job.currency) {
					this.currency = this.currencies.find(c => { return c.id === job.currency.id });

					if (this.currency ) {
						const countries = this.currency.countries || [];
						const country = countries.find(c => { return job.country && c.id === job.country.id }) || countries[0];
						if (!country) return;

						this.tax_perc = Number(country.tax_perc);
						
						/** has_tax=true => Tax applies; has_tax=false => Tax free */
						this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
						this.onTaxSettingChange(this.tax_setting);
					}
				}

				if (this.kind) {
					this.getMarkup(job.id, this.kind.id);
				}
			}
		},
		getPhases(job_id) {
			axios
				.get(`/api/jobs/${job_id}/phases`, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.phase_items = data;

						if (data.length !== 0) {
							this.phase = data[0];
						} else {
							this.phase = null;
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onKindSelected(kind) {
			this.kind = kind;
			this.kind_init = kind;

			if (kind && this.job) {
				this.getMarkup(this.job.id, kind.id);
			}
		},
		onCurrencyChange(currency) {
			if (currency) {
				const countries = currency.countries || [];
				const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
				if (!country) return;

				this.tax_perc = Number(country.tax_perc);
						
				/** has_tax=true => Tax applies; has_tax=false => Tax free */
				this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
				this.onTaxSettingChange(this.tax_setting);
			}
		},
		onTaxSettingChange(tax_setting) {
			if (!tax_setting) {
				this.has_tax = false;
				this.tax_amount = 0;
				return;
			}

			this.tax_setting = tax_setting;
			
			if (tax_setting.value === 1 || tax_setting.value === 4) {
				this.has_tax = false;
				this.tax_amount = 0;
			} else {
				this.has_tax = true;
				this.tax_amount = Number(this.amount) * this.tax_perc * 0.01;
			}
		},
		onTaxAmountChange(value) {
			this.tax_amount = this.parseAmount(value);

			if (Number(this.tax_amount) === 0) {
				const tax_free_setting = this.tax_settings.find(setting => setting.value === 1);

				if (tax_free_setting) {
					this.onTaxSettingChange(tax_free_setting);
				}
			}
		},
		onShowToogle() {
			this.is_show_toogle = !this.is_show_toogle;

			const win_setup_obj = {
				toogle: this.is_show_toogle,
			};
			const win_setup_str = JSON.stringify(win_setup_obj);

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onAddFile() {
			this.$emit('add-file', this.receipt);
		},
		onImageRemove() {
			this.$emit('del-file', this.receipt);
		},
		onSave() {
			if (!this.isSaveEnabled) return;

			if (this.job && this.kind && this.kind.overhead_mode === 1 && !this.job.is_overhead) {
				this.error_msg = "You can't use an overhead kind on a client job";
				return ;
			} else if (this.job && this.kind && this.kind.overhead_mode === 0 && this.kind.show_over === 0 && this.job.is_overhead) {
				this.error_msg = "You can't use a client kind on an overhead job";
				return ;
			};

			const updateReceipt = this._createReceipt();

			this.$emit('save', updateReceipt);
		},
		onCancel() {
			this.$emit('delete', this.receipt.id);
		},
		_checkKind(job_id, kind_id, phase_id) {
			let url = `/api/jobs/${job_id}/can_do_kind`;

			const params = [];
			params.push("kiid=" + kind_id);
			params.push("jpid=" + phase_id);


			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (!data.can_do_client || !data.can_do_jobtype) {
							this.kind = null;
							this.kind_init = null;
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		_createReceipt() {
			const new_receipt = {
				/* image - we don't update the image */
				id: this.receipt.id,
				employee_id: this.receipt.employee.id,
				desc: this.description,
				date: moment(this.expenses_date).format("YYYY-MM-DD"),
				currency_id: this.currency.id,
				gross: this.parseAmount(this.amount),
				has_tax: this.has_tax ? 1 : 0, /* has tax (axios isn't supporting boolean so 1 = true) */
				job_id: this.job ? this.job.id : null,
				phase_id: this.phase ? this.phase.id : null,
				kind_id: this.kind ? this.kind.id : null,
				tax_mode: this.tax_setting ? this.tax_setting.value : (Number(this.tax_amount) !== 0 ? 0 : 1),
				tax_perc: Number(this.tax_perc) || 0,
				tax_amount: Number((Number(this.tax_amount) || 0).toFixed(2)),
				markup_perc: Number(this.markup_perc) || 0,
				value: this.parseAmount(this.valueAmount),
			};

			return new_receipt;
		}
	}
}
</script>
<style lang="scss" scoped>
.receipt-col {
	padding: 10px;
}
.receipt-box {
	background: #FFFFFF;
	padding: 20px;
	border: 1px solid rgba(25, 42, 62, 0.3);
	border-radius: 4px;
}
.receipt-box-close {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	.close {
		&:hover {
			cursor: pointer;
		}
	}
}
.receipt-box-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}
.receipt-box-btn {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	// margin-top: 16px;
	:first-child {
		padding: 0 20px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		border-radius: 4px;
		margin-right: 8px;
	}
	:last-child {
		padding: 0 20px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		border-radius: 4px;
	}
}
.receipt-box-btn-sm {
	justify-content: center;
}
.receipt-box-btn-lg {
	justify-content: flex-start;
}
.receipt-box-btn-copy {
	justify-content: space-between;
}
.btn-able {
	color: #FFFFFF;
	background: #00AAFD;
	border: 1px solid #00AAFD;
	&:hover {
		cursor: pointer;
	}
}
.btn-remove-able {
	color: rgba(25, 42, 62, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
	&:hover {
		cursor: pointer;
	}
}
.btn-disable {
	color: rgba(25, 42, 62, 0.3);
	border: 1px solid rgba(25, 42, 62, 0.3);
}
.more-text {
	float: right;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;
	color: #00AAFD;
	&:hover {
		cursor: pointer;
	}
}
.add-file-btn {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.add-file-button {
	min-width: 112px !important;
	padding: 0 12px !important;
	border-radius: 4px;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: 0.25px;
}
.image-loading {
	background:#C4C4C4;
}
.image-remove {
	position: relative;
	top: -20px; 
	right: -10px;
}
.mark-up-field ::v-deep .v-input__append-inner .v-icon {
	font-size: 16px;
}
</style>
